module.exports = __webpack_public_path__ + "media/images/cover-5-04fd16d029a82b62446bdf2916a23e0a.jpg";